<script>
import { mapActions, mapGetters, mapState } from "vuex";

import orderMixin from "@/mixins/orderMixin";

import Payable from "../Payable/Index";
import Payment from "../Payment/Payment";
import Success from "../Success";

export default {
  mixins: [orderMixin],

  components: {
    Payable,
    Payment,
    Success
  },

  methods: {
    ...mapActions("payable", ["reset", "getPayable", "getStoredCreditCards"]),

    async setPayable() {
      const validPayable = await this.getPayable({
        id: this.getPayableId(),
        type: "order"
      });

      if (!validPayable) {
        if (!window.ReactNativeWebView) return;

        window.ReactNativeWebView.postMessage(null);

        return;
      }

      if (!this.canGoToCheckout(this.payable)) {
        if (!window.ReactNativeWebView) return;

        window.ReactNativeWebView.postMessage(this.getPayableId());
      }
    },

    async setStoredCreditCards() {
      await this.getStoredCreditCards();
    },

    getPayableId() {
      return this.$route.params.order_id;
    }
  },

  computed: {
    ...mapState("payable", ["payable"]),
    ...mapGetters("payable", ["payablePaid"])
  },

  async mounted() {
    await this.reset();
    await this.setPayable();
    await this.setStoredCreditCards();

    $crisp.push([
      "on",
      "session:loaded",
      () => {
        $crisp.push(["do", "chat:hide"]);
      }
    ]);
  },

  async beforeDestroy() {
    await this.reset();
  }
};
</script>

<template>
  <div class="container">
    <div class="row">
      <transition-group name="zoom" mode="out-in">
        <div key="success" v-if="payablePaid">
          <Success class="card" :payable="payable" />
        </div>

        <div key="payment" v-else>
          <Payable />
          <Payment />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 992px) {
  .row {
    flex-direction: column !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Order/Index.vue